<template>
  <div class="preloader" v-if="getPreloaderStatus">
    <div class="preloader__loader"></div>
  </div>
</template>

<script>
export default {
  name: "Preloader",
  computed: {
    getPreloaderStatus() {
      return this.$store.getters.getPreloaderStatus;
    },
  }
};
</script>

<style lang="scss">
.preloader {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 99999999;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &__loader {
    border: 8px solid #f3f3f3; /* Light grey */
    border-top: 8px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
